<template>
  <a-dropdown v-if="userInfo.id" :trigger="['click']">
    <a-button type="link" class="account-control" aria-haspopup="menu" :aria-label="`个人中心：${singnumber}`">
      <a-icon type="user" class="account-icon" />
      <span>个人中心</span>
    </a-button>
    <a-menu slot="overlay" @click="handleMenuClick">
      <a-menu-item v-if="userInfo.phone_number" key="account" disabled>
        <span>当前账号：{{ singnumber }}</span>
      </a-menu-item>
      <a-menu-divider v-if="userInfo.phone_number" />
      <a-menu-item key="userinfo">
        <div class="leading-8">
          <a-icon type="user" style="font-size: 18px; line-height: 32px" />
          <span class="pl-2">个人资料</span>
        </div>
      </a-menu-item>
      <a-menu-item key="logout">
        <div class="leading-8">
          <a-icon type="poweroff" style="font-size: 18px; line-height: 32px" />
          <span class="pl-2">退出登录</span>
        </div>
      </a-menu-item>
    </a-menu>
  </a-dropdown>
  <a-button v-else type="link" class="account-control account-control--login" @click="gotoLogin">
    <a-icon type="user" class="account-icon" />
    <span>登录</span>
  </a-button>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('user', ['userInfo']),
    singnumber() {
      const phone = String(this.userInfo.phone_number || '');
      return phone ? `${phone.slice(0, 3)}****${phone.slice(7)}` : '个人中心';
    },
  },
  methods: {
    handleMenuClick({ key }) {
      switch (key) {
        case 'userinfo':
          this.$router.push('/admin/info');
          return;
        case 'logout':
          this.$confirm({
            title: '温馨提示',
            content: '是否退出登录',
            onOk: async () => {
              await this.$store.dispatch('user/logout');
              this.$router.push('/');
            },
          });
          return;
      }
    },
    gotoLogin() {
      if (!this.userInfo.id) {
        this.$store.commit('user/SET_LOGINSTATE', { state: 'PASSWORD' });
        this.$store.commit('user/SET_LOGINFLAG', true);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.account-control.ant-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 44px;
  padding: 10px 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  color: #424245;
  font-family: inherit;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.5;
  box-shadow: none;
  text-shadow: none;
  white-space: nowrap;
  transition: color .15s;
}
.account-control.ant-btn-link::after { display: none; }
.account-control.ant-btn:hover, .account-control.ant-btn:focus, .account-control--login.ant-btn { color: #0066cc; }
.account-control .account-icon { font-size: 18px; }
.account-control.ant-btn > .anticon + span { margin-left: 0; }
.account-control.ant-btn:focus-visible { outline: 2px solid #0071e3 !important; outline-offset: 4px; }
@media (prefers-reduced-motion: reduce) {
  .account-control.ant-btn { transition: none; }
}
</style>
